// a b c d e f g h i j k l m n o p q r s t u v w x y z

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ifProp } from 'styled-tools';

import WellBody from './Body';
import WellFooter from './Footer';
import WellHeader from './Header';
import WellSubtitle from './Subtitle';
import WellTitle from './Title';
import { Icon } from 'components/shared';

const propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

const defaultProps = {
  children: undefined,
  title: undefined,
  subtitle: undefined,
};

function Well({ title, subtitle, children, ...props }) {
  let body;
  let header;
  let footer;

  React.Children.forEach(children, (child) => {
    switch (child.key) {
      case 'body':
        body = child;
        break;
      case 'header':
        header = child;
        break;
      case 'footer':
        footer = child;
        break;
      default:
        break;
    }
  });

  if (!body && !header && !footer) {
    return (
      <StyledWell {...props}>
        <StyledWellBody>
          {title && <> <StyledWellTitle subtitle={!!subtitle}><IconDiv><Icon icon="lightbulb" /></IconDiv> {title}</StyledWellTitle></>}
          {subtitle && <StyledWellSubtitle>{subtitle}</StyledWellSubtitle>}
          {children}
        </StyledWellBody>
      </StyledWell>
    );
  }
  return (
    <StyledWell {...props}>
      {header && header}
      {body && body}
      {footer && footer}
    </StyledWell>
  );
}

const StyledWellBody = styled(WellBody)`
  padding: 40px 55px 25px;
  @media (max-width: 768px) {
    padding: 40px 20px 25px;
  }
`;

const StyledWellTitle = styled(WellTitle)`
  color: var(--color-primary);
  display: flex;
  align-items: center;
  margin-bottom: ${ifProp('subtitle', '10px', '30px')};
  @media (max-width: 768px) {
    font-size: var(--font-size-m);
    flex-direction: column;
    gap: 10px;
  }
`;

const StyledWellSubtitle = styled(WellSubtitle)`
  margin-bottom: 30px;
`;

const IconDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-icon-background);
  border-radius: 100%;
  width: 2em;
  height: 2em;
  margin-right: 10px;
`;

const StyledWell = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
`;

Well.propTypes = propTypes;
Well.defaultProps = defaultProps;

export { WellBody, WellFooter, WellHeader, WellSubtitle, WellTitle };
export default Well;
